import React from 'react';
import { Outlet, useSearchParams, Navigate } from 'react-router-dom';
import { ProjectSidebar } from './components/ProjectSidebar';
import { PublicLinkSidebar } from './components/PublicLinkSidebar';
import { SidebarProvider } from './components/ui/sidebar';
import { useAuth } from './contexts/AuthContext';
import { ProjectAccessProvider } from './contexts/ProjectAccessContext';
import { CreateEntityFromMentionProvider } from './contexts/CreateEntityFromMentionContext';
import { CreateEntityFromMentionHost } from './components/CreateEntityFromMentionHost';
import { OpenEntityDetailProvider } from './contexts/OpenEntityDetailContext';
import { OpenEntityDetailHost } from './components/OpenEntityDetailHost';
import { MentionClickHandler } from './components/MentionClickHandler';
import { DocumentLoadingPanel } from './components/DocumentLoadingPanel';

export const Project: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { token, loading: authLoading } = useAuth();
  const shareToken = searchParams.get('shareToken');
  const isPublicLinkWithoutAuth = shareToken && !token;

  if (!token && !shareToken && !authLoading) {
    return <Navigate to="/login" replace />;
  }

  return (
    <SidebarProvider>
      <ProjectAccessProvider>
        <CreateEntityFromMentionProvider>
          <OpenEntityDetailProvider>
            {isPublicLinkWithoutAuth ? <PublicLinkSidebar /> : <ProjectSidebar />}
            {authLoading ? <DocumentLoadingPanel /> : <Outlet />}
            <MentionClickHandler />
            <OpenEntityDetailHost />
            <CreateEntityFromMentionHost />
          </OpenEntityDetailProvider>
        </CreateEntityFromMentionProvider>
      </ProjectAccessProvider>
    </SidebarProvider>
  );
};

export default Project;

